<template>
  <v-dialog scrollable v-model="value" max-width="800" persistent>
    <v-card v-if="admin">
      <div class="text-xs-right">
        <v-btn flat fab small @click="onCancel" :loading="loading"
          ><v-icon small>close</v-icon></v-btn
        >
      </div>
      <v-card-text>
        <v-layout wrap>
          <v-flex xs12 sm12 class="form-control" :class="{ 'has-error': errors.has('image') }">
            <uploadfile
              v-model="admin.image_url"
              data-vv-as="Image"
              :height="150"
              :data-vv-name="'image'"
              @onUploaded="onUploaded"
              v-validate="'required'"
              style="width: 150px; margin: auto"
            ></uploadfile>
            <div class="text-error text-xs-center error--text" v-if="errors.has('image')">
              {{ errors.first('image') }}
            </div>
          </v-flex>

          <v-flex xs12 sm6 class="form-control pa-1" :class="{ 'has-error': errors.has('code') }">
            <label for>{{ $t('Code') }}</label>
            <input
              type="text"
              name="code"
              :placeholder="$t('Code')"
              :data-vv-as="$t('Code')"
              v-model.lazy="admin.aston_code"
              class="form-control"
              maxlength="255"
              v-validate="'required'"
            />
            <span class="text-error" v-if="errors.has('code')">{{ errors.first('code') }}</span>
          </v-flex>

          <v-flex xs12 sm6 class="form-control pa-1" :class="{ 'has-error': errors.has('name') }">
            <label for>{{ $t('name') }}</label>
            <input
              type="text"
              name="name"
              :placeholder="$t('name')"
              :data-vv-as="$t('name')"
              v-model.lazy="admin.name"
              class="form-control"
              maxlength="255"
              v-validate="'required'"
            />
            <span class="text-error" v-if="errors.has('name')">{{ errors.first('name') }}</span>
          </v-flex>
          <v-flex xs12 sm6 class="form-control pa-1" :class="{ 'has-error': errors.has('symbol') }">
            <label for>{{ $t('Symbol') }}</label>
            <input
              type="text"
              name="symbol"
              :placeholder="$t('Symbol')"
              :data-vv-as="$t('Symbol')"
              v-model.lazy="admin.symbol"
              class="form-control"
              maxlength="255"
              v-validate="'required'"
            />
            <span class="text-error" v-if="errors.has('symbol')">{{ errors.first('symbol') }}</span>
          </v-flex>
          <v-flex
            xs12
            sm6
            class="form-control pa-1"
            :class="{ 'has-error': errors.has('starttime') }"
          >
            <label for>{{ $t('Start Time') }}</label>
            <input
              type="text"
              :placeholder="$t('Start Time')"
              :data-vv-as="$t('Start Time')"
              name="starttime"
              :mask="'##:##'"
              v-model.lazy="admin.starttime"
              class="form-control"
              maxlength="255"
              v-validate="{ required: true, regex: /[0-9]{2}[:][0-9]{2}$/ }"
            />
            <span class="text-error" v-if="errors.has('starttime')">{{
              errors.first('starttime')
            }}</span>
          </v-flex>
          <v-flex
            xs12
            sm6
            class="form-control pa-1"
            :class="{ 'has-error': errors.has('endtime') }"
          >
            <label for>{{ $t('End Time') }}</label>
            <input
              type="text"
              :placeholder="$t('End Time')"
              :data-vv-as="$t('End Time')"
              :mask="'##:##'"
              name="endtime"
              v-model.lazy="admin.endtime"
              class="form-control"
              maxlength="255"
              v-validate="{ required: true, regex: /[0-9]{2}[:][0-9]{2}$/ }"
            />
            <span class="text-error" v-if="errors.has('endtime')">{{
              errors.first('endtime')
            }}</span>
          </v-flex>
        </v-layout>

        <div class="text-xs-center">
          <v-btn outline color="grey" @click="onCancel" :loading="loading">{{
            $t('cancel')
          }}</v-btn>
          <v-btn depressed color="primary" @click="onSave" :loading="loading">{{
            $t('Save')
          }}</v-btn>
        </div>
      </v-card-text>
    </v-card>
  </v-dialog>
</template>

<script>
import uploadfile from '@/components/elements/uploadfile'
import dayjs from 'dayjs'
export default {
  components: {
    uploadfile
  },
  props: {
    value: {
      default: false
    },
    data: {
      default: () => {
        return {
          aston_code: '',
          image_url: '',
          name: '',
          symbol: '',
          starttime: '10:00',
          endtime: '18:00'
        }
      }
    }
  },
  data() {
    return {
      admin: null,
      loading: false
    }
  },
  mounted() {
    this.admin = this.data
    if (this.admin) {
      var now = dayjs().format('YYYY-MM-DD')
      try {
        if (dayjs(`${now} ${this.admin.starttime}`, 'YYYY-MM-DD HH:mm:ssZ').isValid()) {
          this.$set(
            this.admin,
            'starttime',
            dayjs(`${now} ${this.admin.starttime}`, 'YYYY-MM-DD HH:mm:ssZ').format('HH:mm')
          )
        }

        if (dayjs(`${now} ${this.admin.endtime}`, 'YYYY-MM-DD HH:mm:ssZ').isValid()) {
          this.$set(
            this.admin,
            'endtime',
            dayjs(`${now} ${this.admin.endtime}`, 'YYYY-MM-DD HH:mm:ssZ').format('HH:mm')
          )
        }
      } catch (error) {}
    }
  },
  methods: {
    onUploaded(url) {},
    onCancel() {
      this.$emit('input', false)
    },
    async onSave() {
      var vm = this
      let result = await this.$validator.validateAll()
      if (!result) {
        // do stuff if not valid.
        this.goToErrorInput()
        return false
      }
      this.loading = true
      this.$emit('saveAdmin', {
        admin: this.admin,
        oncomplete: function() {
          vm.$emit('input', false)
          vm.loading = false
        }
      })
    }
  }
}
</script>

<style lang="scss" scoped></style>



// WEBPACK FOOTER //
// src/components/view/analytics/AstonAdminManage.vue